// extracted by mini-css-extract-plugin
module.exports = {"contentInput":"Input_contentInput__1rbJ9","description":"Input_description__30G7k","labelInput":"Input_labelInput__108eS","errorInput":"Input_errorInput__1tUGj"};